var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.visible
    ? _c(
        "div",
        {
          staticClass: "overlay",
          on: {
            click: function ($event) {
              if ($event.target !== $event.currentTarget) return null
              return _vm.$emit("close")
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "modal", class: { "is-shopify": !_vm.isShoplazza } },
            [
              _c("div", { staticClass: "modal-head" }, [
                _c("div", { staticClass: "modal-icon" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "20",
                        height: "20",
                        viewBox: "0 0 16 16",
                        fill: "currentColor",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M13.485 1.929a.75.75 0 0 1 0 1.06l-7.778 7.778a.75.75 0 0 1-1.06 0L1.515 6.636a.75.75 0 1 1 1.06-1.06l2.657 2.657 7.248-7.248a.75.75 0 0 1 1.06 0z",
                        },
                      }),
                    ]
                  ),
                ]),
                _c("div", { staticClass: "modal-head-text" }, [
                  _c("h3", [
                    _vm._v(
                      _vm._s(
                        _vm.alreadyBound
                          ? "App Already Bound"
                          : "Authorization Confirmed"
                      )
                    ),
                  ]),
                  _vm.isShoplazza
                    ? _c("p", [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.alreadyBound
                                ? `This App is already bound to your ${_vm.platformLabel} store. You can copy the credentials again or open the settings page.`
                                : `Copy the credentials below and paste them into the ${_vm.platformLabel} plugin settings to complete setup.`
                            ) +
                            "\n        "
                        ),
                      ])
                    : _vm._e(),
                ]),
                _c(
                  "button",
                  {
                    staticClass: "modal-close",
                    attrs: { type: "button", "aria-label": "Close" },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("close")
                      },
                    },
                  },
                  [_vm._v("×")]
                ),
              ]),
              _c("div", { staticClass: "modal-body" }, [
                _c(
                  "div",
                  {
                    staticClass: "panel-left",
                    class: { "is-full": !_vm.isShoplazza },
                  },
                  [
                    _c("div", { staticClass: "section" }, [
                      _c("p", { staticClass: "section-label" }, [
                        _vm._v("Binding Summary"),
                      ]),
                      _c("div", { staticClass: "summary-card" }, [
                        _c("div", { staticClass: "summary-row" }, [
                          _c("span", { staticClass: "summary-label" }, [
                            _vm._v("App Name"),
                          ]),
                          _c("span", { staticClass: "summary-value" }, [
                            _vm._v(_vm._s(_vm.appName || "—")),
                          ]),
                        ]),
                        _c("div", { staticClass: "summary-row" }, [
                          _c("span", { staticClass: "summary-label" }, [
                            _vm._v(_vm._s(_vm.platformLabel) + " Store Name"),
                          ]),
                          _c(
                            "span",
                            {
                              staticClass: "summary-value summary-value-muted",
                            },
                            [_vm._v(_vm._s(_vm.storeName || "—"))]
                          ),
                        ]),
                        _vm.alreadyBound
                          ? _c(
                              "div",
                              { staticClass: "summary-row summary-row-bound" },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "summary-label summary-label-bound",
                                  },
                                  [_vm._v("Binding Status")]
                                ),
                                _c("span", { staticClass: "summary-bound" }, [
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        width: "14",
                                        height: "14",
                                        viewBox: "0 0 16 16",
                                        fill: "currentColor",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          d: "M13.485 1.929a.75.75 0 0 1 0 1.06l-7.778 7.778a.75.75 0 0 1-1.06 0L1.515 6.636a.75.75 0 1 1 1.06-1.06l2.657 2.657 7.248-7.248a.75.75 0 0 1 1.06 0z",
                                        },
                                      }),
                                    ]
                                  ),
                                  _vm._v(
                                    "\n                Already Bound\n              "
                                  ),
                                ]),
                              ]
                            )
                          : _vm._e(),
                      ]),
                    ]),
                    _vm.isShoplazza
                      ? _c("credential-copy-field", {
                          attrs: {
                            label: "merNo (App ID)",
                            value: _vm.merNo,
                            copied: _vm.copiedField === "id",
                          },
                          on: {
                            copy: function ($event) {
                              return _vm.copyText(_vm.merNo, "id")
                            },
                          },
                        })
                      : _vm._e(),
                    _vm.isShoplazza
                      ? _c("credential-copy-field", {
                          attrs: {
                            label: _vm.secretKeyLabel,
                            value: _vm.secretKeyValue,
                            copied: _vm.copiedField === "key",
                          },
                          on: {
                            copy: function ($event) {
                              return _vm.copyText(_vm.secretKeyValue, "key")
                            },
                          },
                        })
                      : _vm._e(),
                    _vm.isShoplazza
                      ? _c(
                          "button",
                          {
                            staticClass: "btn-copy-both",
                            attrs: { type: "button" },
                            on: { click: _vm.copyBoth },
                          },
                          [
                            _vm.copiedField === "both"
                              ? [
                                  _c(
                                    "svg",
                                    {
                                      staticClass: "icon-success",
                                      attrs: {
                                        width: "16",
                                        height: "16",
                                        viewBox: "0 0 16 16",
                                        fill: "currentColor",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          d: "M13.485 1.929a.75.75 0 0 1 0 1.06l-7.778 7.778a.75.75 0 0 1-1.06 0L1.515 6.636a.75.75 0 1 1 1.06-1.06l2.657 2.657 7.248-7.248a.75.75 0 0 1 1.06 0z",
                                        },
                                      }),
                                    ]
                                  ),
                                  _c("span", { staticClass: "copied-text" }, [
                                    _vm._v("Copied both!"),
                                  ]),
                                ]
                              : [
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        width: "16",
                                        height: "16",
                                        viewBox: "0 0 16 16",
                                        fill: "currentColor",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          d: "M0 6.75C0 5.784.784 5 1.75 5h1.5a.75.75 0 0 1 0 1.5h-1.5a.25.25 0 0 0-.25.25v7.5c0 .138.112.25.25.25h7.5a.25.25 0 0 0 .25-.25v-1.5a.75.75 0 0 1 1.5 0v1.5A1.75 1.75 0 0 1 9.25 16h-7.5A1.75 1.75 0 0 1 0 14.25v-7.5z",
                                        },
                                      }),
                                      _c("path", {
                                        attrs: {
                                          d: "M5 1.75C5 .784 5.784 0 6.75 0h7.5C15.216 0 16 .784 16 1.75v7.5A1.75 1.75 0 0 1 14.25 11h-7.5A1.75 1.75 0 0 1 5 9.25v-7.5zm1.75-.25a.25.25 0 0 0-.25.25v7.5c0 .138.112.25.25.25h7.5a.25.25 0 0 0 .25-.25v-7.5a.25.25 0 0 0-.25-.25h-7.5z",
                                        },
                                      }),
                                    ]
                                  ),
                                  _vm._v(
                                    "\n            Copy merNo & Sign Key together\n          "
                                  ),
                                ],
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm.isShoplazza
                      ? _c(
                          "button",
                          {
                            staticClass: "btn-green",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.$emit("open-settings")
                              },
                            },
                          },
                          [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  width: "16",
                                  height: "16",
                                  viewBox: "0 0 16 16",
                                  fill: "currentColor",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d: "M6.22 3.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L9.94 8 6.22 4.28a.75.75 0 0 1 0-1.06z",
                                  },
                                }),
                              ]
                            ),
                            _vm._v(
                              "\n          Open " +
                                _vm._s(_vm.platformLabel) +
                                " App Settings\n        "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _vm.isShoplazza
                  ? _c(
                      "div",
                      { staticClass: "panel-right" },
                      [
                        _c("setup-guide", {
                          attrs: {
                            platform: _vm.platform,
                            "platform-label": _vm.platformLabel,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
              _vm.isShopify
                ? _c("p", { staticClass: "redirect-hint" }, [
                    _vm._v(
                      "\n      Return to the Shopify page after " +
                        _vm._s(_vm.countdown) +
                        " s...\n    "
                    ),
                  ])
                : _vm._e(),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }